import { useCallback, useState } from 'react'
import InputField from '../../../components/InputField'
import ApiRoute from '../../../components/ApiRoute'

const BasicPlans = ({ callApiFn, isApiCalling }) => {
  const [suppCount, setSuppCount] = useState('3')
  const [page, setPage] = useState('1')
  const [limit, setLimit] = useState('250')

  const getBasicPlans = useCallback(() => {
    const query = {}
    if (suppCount) query.suppCount = suppCount
    if (page && page !== '1') query.page = page
    if (limit && limit !== '250') query.limit = limit
    const hasQuery = Object.keys(query).length > 0

    callApiFn({
      method: 'GET',
      route: 'contact/{id}/plans',
      ...(hasQuery ? { query } : {})
    })
  }, [suppCount, page, limit, callApiFn])

  return (
    <div>
      <div className='grid grid-cols-3 gap-2 mb-2'>
        <InputField labelFor='suppCount' type='text' id='suppCount' name='suppCount' onChange={(e) => setSuppCount(e.target.value)} value={suppCount}>
          Supp. Count
        </InputField>
        <InputField labelFor='bpPage' type='number' id='bpPage' name='bpPage' onChange={(e) => setPage(e.target.value)} value={page} min='1'>
          Page
        </InputField>
        <InputField labelFor='bpLimit' type='number' id='bpLimit' name='bpLimit' onChange={(e) => setLimit(e.target.value)} value={limit} min='1'>
          Limit
        </InputField>
      </div>
      <ApiRoute method='GET' route='/contact/{contactId}/plans' onClick={getBasicPlans} disabled={isApiCalling} />
    </div>
  )
}

export default BasicPlans
